import { GET_TEAM } from "graphql/queries";
import { useQueryData, useAuth } from "hooks";

const keyName = "team";

export default function useTimeSheetSummary({ week, year, teamId } = {}) {
  const { profileId } = useAuth();
  const { loading, data } = useQueryData({
    queryName: GET_TEAM(false, false),
    keyName,
    variables: {
      id: teamId,
      profileId,
      timeSheetSummary: true,
      week,
      year,
    },
  });

  return {
    loading: loading,
    data: data?.[keyName],
  };
}
